import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { bieuDoApi } from "../../../api/bieu-do/bieuDoApi";
import { IBieuDoRequest } from "../../../model/request/bieu-do/IBieuDoRequest";
import { IBieuDoResponse } from "../../../model/respone/bieu-do/IBieuDoResponse";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eBieuDoActionTypeIds,
  IBieuDoActionTypes,
} from "../../action-types/bieu-do/IBieuDoActionTypes";
import { rootActions } from "../../actions/rootActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

export function* bieuDoSaga(): any {
  yield takeEvery(eBieuDoActionTypeIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IBieuDoActionTypes): any {
  const request = action.payload as IBieuDoRequest;
  const res: IBaseRespone = yield call(bieuDoApi.Select, request);
  if (res.is_success) {
    const data = res.data as any[];
    yield put(
      rootActions.bieuDo.bieuDo.LOAD_SUCCESS({
        data: data,
        type: request.type,
        status: eReducerStatusBase.is_completed,
      } as IBieuDoResponse)
    );
  } else {
    yield put(rootActions.bieuDo.bieuDo.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
